import classNames from 'classnames'
import React from 'react'
import { selectAddressKeywords, selectGeoentityAdsKeywords, selectItineraryKeywords } from '../../store/ad/ad.selectors'
import { isPE } from '../Device'
import AdLoader from './AdLoader'
import s from './InlineMobileAdBanner.less'

const InlineMobileAdBanner = ({ adName, keywordsSelector, className, placeHolderHeight = 50 }) => {
  if (__SERVER__ || (__BROWSER__ && isPE())) {
    return (
      <div className={classNames(s.container, className)}>
        <AdLoader
          adName={adName}
          className={s.content}
          keywordsSelector={keywordsSelector}
          placeHolderHeight={placeHolderHeight}
        />
      </div>
    )
  }
  return <></>
}

export const AdMobileBannerAddress = () => (
  <InlineMobileAdBanner adName="address_banner_mobile" keywordsSelector={selectAddressKeywords} />
)

export const AdMobileBannerGeoentity = () => (
  <InlineMobileAdBanner adName="poi_banner_mobile" keywordsSelector={selectGeoentityAdsKeywords} />
)

export const AdMobileBannerItineraryHP = () => <InlineMobileAdBanner adName="hp_itinerary_banner_mobile" />

export const AdMobileBannerRoadbook = () => (
  <InlineMobileAdBanner adName="roadbook_banner_mobile" keywordsSelector={selectItineraryKeywords} />
)
